<template>
  <div>
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
        <b-breadcrumb-item active>
          {{ $t('global.devices') }}
        </b-breadcrumb-item>
      </b-breadcrumb>
      <b-button type="is-primary" @click="$router.push({ name: 'firmware-list' })">{{ $t('firmwares.title') }}</b-button>
    </div>
    <div class="list-table-container">
      <b-table :data="deviceList" striped :loading="loading.devices" 
        sort-icon="menu-up" default-sort="updatedAt" default-sort-direction="desc"
        @click="handleRowClick">
        <b-table-column field="id" sortable :label="$t('devices.id')" v-slot="props">
          {{ props.row.id }}
        </b-table-column>
        <b-table-column field="name" sortable :label="$t('devices.name')" v-slot="props">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column field="model" sortable :label="$t('devices.model')" v-slot="props">
          {{ props.row.model }}
        </b-table-column>
        <b-table-column field="model" sortable :label="$t('devices.status')" v-slot="props">
          {{ $t('status.'+props.row.status) }}
        </b-table-column>
        <b-table-column field="updatedAt" sortable :label="$t('devices.lastConnect')" numeric v-slot="props">
          {{ $d(new Date(props.row.updatedAt), 'short') }}
        </b-table-column>
        <template #empty>
          <div class="has-text-centered mt-4 mb-4">
            {{ $t('devices.noDevices') }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex'
import router from "@/router";

export default defineComponent({
  name: 'DeviceList',
  setup() {
    const store = useStore()

    const deviceList = computed(() => Object.values((store.state as any).devices || {}))
    const loading = computed(() => (store.state as any).loading)

    const showDeviceDetails = (device: { id: number }) => {
      router.push({ name: 'device-details', params: { id: device.id } });
    };

    const handleRowClick = (row: { id: number }) => {
      showDeviceDetails(row);
    };

    return {
      deviceList,
      loading,
      showDeviceDetails,
      handleRowClick,
    };
  },
});
</script>
